const MealsMenus = () => import("./views/MealsMenus.vue");
const MealsMenuEdit = () => import("./views/MealsMenuEdit.vue");
const MealsMenuImport = () => import("./views/MealsMenuImport.vue");
const MealsMenuImportToExisting = () => import("./views/MealsMenuImportToExisting.vue");
const MealsMenusPrints = () => import("./views/MealsMenusPrints.vue");

const route = "/mealsMenus";

export default [
  {
    path: route,
    name: "mealsMenus.list",
    component: MealsMenus,

    meta: {
      roles: [
        "ROLE_ADMIN",
        "ROLE_INSTITUTIONS_ADMIN",
        "ROLE_PARENT",
        "ROLE_INSTITUTION_WORKER",
        "ROLE_COOK",
      ],
    },
  },

  {
    path: `${route}/create`,
    name: "mealsMenus.create",
    component: MealsMenuEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:mealsMenuId/edit`,
    name: "mealsMenus.edit",
    component: MealsMenuEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:mealsMenuId/import`,
    name: "mealsMenus.importToExisting",
    component: MealsMenuImportToExisting,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/import`,
    name: "mealsMenus.import",
    component: MealsMenuImport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/mealsMenusPrints",
    name: "mealsMenus.prints",
    component: MealsMenusPrints,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
